const sortByNumberOfJetpasses = (a, b) => {
  if (a.numberOfJetpasses === b.numberOfJetpasses) {
    return 0;
  }

  return a.numberOfJetpasses > b.numberOfJetpasses ? -1 : 1;
};

export { sortByNumberOfJetpasses };
